import { Component, OnInit, trigger, state, animate, transition, style } from '@angular/core';
import { WpService } from '../service/wp.service'

@Component({
  selector: 'app-calender',
  templateUrl: './calender.component.html',
  styleUrls: ['./calender.component.scss'],
  animations: [
    trigger('slideDown', [
      state('false', style({height: '0px'})),
      state('true', style({height: '*'})),
      transition('* => *', animate('300ms'))
    ])
  ]
})
export class CalenderComponent implements OnInit {

  date = new Date();

  dates = undefined;

  constructor(private wp: WpService) { }


  ngOnInit() {
    this.loadCurrent()
  }



  loadCurrent(){
    this.wp.get('calender').subscribe(
      data => {
        this.dates = data
        for(let d of this.dates){
          d.dates[0].date = new Date(d.dates[0].date)
          d.expand = false;
        }
      },
      error => {
        console.error(error)
      }
    )
  }


  addMonth(theDate, month) {
    return new Date(theDate.getFullYear(), theDate.getMonth() + month, theDate.getDate());
  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/calender/calender.component.ts